/**
 * @generated SignedSource<<d09311d43415a20553bee5b21cce5225>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRegistrationPromo_viewer">;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_viewer";
};
export type PdpSharedCondensedSidebarButtons_viewer$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedRegistrationPromo_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4d556de715f948f647e29ea636543dd1";

export default node;
